import PageContainer from '../components/common/PageContainer'
import { useGetAllProcesses } from '../api/process'
import ProcessPageHeader from '../components/process/ProcessPageHeader'
import NewProcessForm from '../components/process/NewProcessForm'
import { Container } from '@mui/material'

export default function CreateProcess() {
  const { data: processes } = useGetAllProcesses()
  return (
    <PageContainer header={<ProcessPageHeader />}>
      <Container maxWidth="lg" sx={{ p: { xs: 0, lg: 1 } }}>
        <NewProcessForm />
      </Container>
    </PageContainer>
  )
}
